import React from "react";
import { Link } from "react-router-dom";
import "./BoardsHero.css";

import heroImg from "../../../../../assets/images/allproducts/boards/boardshero.png";

const BoardsHero = () => {
  return (
    <section className="boardsHero" aria-label="Boards category">
      <div className="boardsHero-container">
        <div className="boardsHero-left">
          <span className="boardsHero-tag">CATEGORIES</span>

          <h1 className="boardsHero-title">Boards</h1>

          <p className="boardsHero-desc">
Our boards provide high performance and durability for interior and exterior use, offering a stable base for walls and ceilings. Easy to install and system-compatible, they ensure long-lasting strength and quality results.
          </p>

          <Link className="boardsHero-link" to="/products">
            Explore all products
            <span className="arrow">↓</span>
          </Link>
        </div>

        <div className="boardsHero-right">
          <img src={heroImg} alt="" draggable={false} />
        </div>
      </div>
    </section>
  );
};

export default BoardsHero;
